const checkIsPermissionPresent = (requiredPermissions: string[], existingPermissions: string[]) => {
  return requiredPermissions.every((requiredPermission) => existingPermissions.includes(requiredPermission));
};

export const checkRequiredPermissions = (
  {
    existingPermissions = [],
    requiredPermissions = [],
    requiredOneOfPermissions = [],
    isSuperAdmin = false,
  }: {
    existingPermissions: string[],
    requiredPermissions: string[],
    requiredOneOfPermissions: string[],
    isSuperAdmin: boolean
  }) => {
  if (isSuperAdmin) {
    return true;
  }
  if (!checkIsPermissionPresent(requiredPermissions, existingPermissions)) {
    return false;
  }
  const requiredAtLeastOnePermission = requiredOneOfPermissions && requiredOneOfPermissions.length;
  if (requiredAtLeastOnePermission &&
    !requiredOneOfPermissions.some((requiredPermission) => checkIsPermissionPresent([ requiredPermission ], existingPermissions))) {
    return false;
  }

  return true;
};
